import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Verify = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="verify icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.74652 2.4678C4.09458 1.60589 7.24434 0 12 0C16.7557 0 19.9054 1.60589 21.2535 2.4678C21.7454 2.78231 22 3.33374 22 3.91759V13C22 18.982 14 24 12 24C10 24 2 18.982 2 13V3.91947C2 3.33562 2.25462 2.78231 2.74652 2.4678ZM18.3107 8.56066C18.8964 7.97487 18.8964 7.02513 18.3107 6.43934C17.7249 5.85355 16.7751 5.85355 16.1893 6.43934L10.25 12.3787L8.31066 10.4393C7.72487 9.85355 6.77513 9.85355 6.18934 10.4393C5.60355 11.0251 5.60355 11.9749 6.18934 12.5607L10.25 16.6213L18.3107 8.56066Z"
    />
  </svg>
)
